import { render, staticRenderFns } from "./blogsEdit.vue?vue&type=template&id=7647d7da&"
import script from "./blogsEdit.vue?vue&type=script&lang=js&"
export * from "./blogsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports